import {
  AnalyticsEventProperties,
  AnalyticsEventValue,
  isExtendedAnalyticsEvent,
} from 'core/analytics/entities/Analytics';
import { AmplitudeService } from '../../interfaces';
import { AmplitudeServiceDecorator } from './AmplitudeServiceDecorator';

const screenOpenEventName = 'funnel_screen_open';

export class AmplitudeServiceWithMonoLanding extends AmplitudeServiceDecorator {
  constructor(
    amplitudeService: AmplitudeService,
    private readonly isMonoLanding: boolean,
  ) {
    super(amplitudeService);
  }

  trackEvent(event: AnalyticsEventValue, properties: AnalyticsEventProperties = {}) {
    const eventName = isExtendedAnalyticsEvent(event) ? event.name : event;

    if (eventName !== screenOpenEventName) {
      return super.trackEvent(event, properties);
    }

    return super.trackEvent(event, { ...properties, is_mono_landing: this.isMonoLanding });
  }
}
